const asc = (arr: number[]) => arr.sort((a, b) => a - b);

const sum = (arr: number[]) => arr.reduce((a, b) => a + b, 0);

const mean = (arr: number[]) => sum(arr) / arr.length;

// sample standard deviation
const std = (arr: number[]) => {
    const mu = mean(arr);
    const diffArr = arr.map(a => (a - mu) ** 2);
    return Math.sqrt(sum(diffArr) / (arr.length - 1));
};

const quantile = (arr: number[], q: number) => {
    const sorted = asc(arr);
    const pos = (sorted.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sorted[base + 1] !== undefined) {
        return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
    } else {
        return sorted[base];
    }
};

const q25 = (arr: number[]) => quantile(arr, .25);

const q50 = (arr: number[]) => quantile(arr, .50);

const q75 = (arr: number[]) => quantile(arr, .75);

const median = (arr: number[]) => q50(arr);


export default {
    asc,
    std,
    sum,
    mean,
    quantile,
    q25,
    q50,
    q75,
    median,
};
